import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { LinkIconPosition, LinkWeight } from '@freelancer/ui/link';
import { PictureLayout } from '@freelancer/ui/picture';
import { TextSize } from '@freelancer/ui/text';

@Component({
  standalone: true,
  imports: [TrackingModule, UiModule],
  selector: 'fl-moonshot-promo-banner',
  template: `
    <section class="PromoBanner">
      <fl-picture
        class="PromoBanner-logo"
        alt="Freelancer Moonshot Innovation Challenges"
        i18n-alt="Moonshot promo banner logo alt text"
        [layout]="PictureLayout.INTRINSIC"
        [src]="'innovation-challenge/innovation-challenge-logo-v3.png'"
      ></fl-picture>
      <div class="PromoBanner-text">
        <h2
          class="text-light text-title-20 font-bold"
          i18n="Moonshot promo banner title"
        >
          You're exploring Freelancer Moonshot Innovation Challenges
        </h2>
        <p
          class="text-light text-body-14"
          i18n="Moonshot promo banner program text"
        >
          See the program overview and how it works
        </p>
      </div>
      <fl-link
        class="PromoBanner-cta"
        i18n="Moonshot promo banner find out more link"
        [flTrackingLabel]="'PromoBannerFindOutMoreClicked'"
        [iconColor]="IconColor.INHERIT"
        [iconName]="'ui-arrow-right'"
        [iconPosition]="LinkIconPosition.RIGHT"
        [iconSize]="IconSize.MID"
        [link]="'/innovation'"
        [size]="TextSize.BUTTON_20"
        [weight]="LinkWeight.BOLD"
      >
        Find out more
      </fl-link>
    </section>
  `,
  styleUrls: ['./moonshot-promo-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoonshotPromoBannerComponent {
  IconColor = IconColor;
  IconSize = IconSize;
  LinkIconPosition = LinkIconPosition;
  LinkWeight = LinkWeight;
  PictureLayout = PictureLayout;
  TextSize = TextSize;
}
